import { logger } from '@/util/logger';

import Spinner from '../modules/spinner.js';

const $ = window.$;

// keep track of click position so we can expand loading opacity from that origin
window.clickOriginX = 0;
window.clickOriginY = 0;

export default {
	$body: [],
	$background: [],
	$message: [],
	timeoutDuration:0,
	timeoutMessage: '',
	_DEFAULT_TIMEOUT: 15000,
	_isRunning: false,
	_promptTimer: null,
	_textTimer: null,
	_spinnerTimer: null,
	_cacheSelectors: function() {
		this.$body = $('body');
		this.$background = $('.js-loading-background');
		this.$message = $('.js-loading-message');
	},
	_clickOriginX: 0,
	_clickOriginY: 0,

	start: function(timeout, message) {
		// don't start again if already running
		if (this._isRunning) return;

		if (!this.isInit) this.init();
		var that = this;
		this.timeoutDuration = timeout * 1000 || this._DEFAULT_TIMEOUT;
		var m = message || 'This request is taking longer than usual.';
		if (m !== this.timeoutMessage) {
			window.async_translate(m, this.$message);
			this.timeoutMessage = m;
		}
		if (this._clickOriginX > 0) {
			try {
				this.$background.css({
					'top': that._clickOriginY - 20,
					'left': that._clickOriginX - 20
				});
			} catch (e) {
				// do nothing
			}
		} else {
			this.$background.css({
				'top': 'calc(50% - 20px)',
				'left':'calc(50% - 20px)'
			});
		}

		// unhide and transition in background
		this.$background.show();
		this.$body.addClass('is-loading');

		// startup spinner
		this._spinnerTimer = setTimeout(function() {
			// Show spinner and begin offset animation
			that.spinner.start.call(that.spinner);
		}, 150);

		// setup timeouts to display progress indicator.
		// at t ms display text "this request is taking longer than usual"
		// at t*2 ms display a confirmation window with text "this request is taking longer than usual. Continue waiting?" [YES] [NO]
		this._textTimer = setTimeout(function() {
			// show text
			that.$message.fadeIn(150);

			that.startPromptTimer(m);

		}, that.timeoutDuration);

		this._isRunning = true;
	},
	clearTimers: function() {
		window.clearTimeout(this._promptTimer);
		window.clearTimeout(this._textTimer);
		window.clearTimeout(this._spinnerTimer);
	},
	startPromptTimer: function(message) {
		var that = this;
		window.clearTimeout(that._promptTimer);

		that._promptTimer = setTimeout(function() {
			// show prompt

			window.confirmModal.prompt(message + ' Would you like to continue waiting?', {
				onYes: function() {
					// restart prompt timer
					that.startPromptTimer(message, that.timeoutDuration*2);
					window.confirmModal.close();
				},
				onNo: function() {
					// if no, remove loading state and close prompt
					window.confirmModal.close();
					that.end();
				},
				onClose: function() {
					// CLOSE click action
					that.startPromptTimer(message,that.timeoutDuration*2);
				}
			});

		}, that.timeoutDuration);
	},
	end: function() {
		var that = this;
		this.$body.removeClass('is-loading');

		this.clearTimers();
		this.$message.hide();
		this.spinner.stop(true);

		setTimeout(function() {
			that.$background.hide();
		}, 100);

		this._isRunning = false;
	},

	spinner: new Spinner('pageLoadingSpinner'),

	init: function() {
		var that = this;
		this._cacheSelectors();
		this.spinner.init();

		if (!this.isInit) {
			$(document).on('click', function(e) {
				that._clickOriginX = e.screnX;
				that._clickOriginY = e.screnY;

				// delete saved click origin
				setTimeout(function() {
					that._clickOriginX = 0;
					that._clickOriginY = 0;
				}, 100);
			});
		}

		this.isInit = true;
	}
};

window.applyLoadingState = function(timeout, message) {
	window.loader.start(timeout,message);
};

window.removeLoadingState = function() {
	try {
		if (window.loader && window.loader.isInit) {
			window.loader.end();
		}
	} catch (err) {
		// if we encounter an error trying to remove the loader, just hide it.
		$('.js-loading-background').hide();
		$('#pageLoadingSpinner').hide();
		$('.js-loading-message').hide();
		logger.log(err);
	}
};